import { CustomLink, CreateCustomLinkRequest, UpdateCustomLinkRequest } from "../types/customLink";
import axiosInstance from "../config/axios";
import HttpService from "./httpService";

export class CustomLinkService {

    static getAllCustomLinks = async (): Promise<CustomLink[]> => {
        try {
            const response = await axiosInstance.get<CustomLink[]>(`/custom-links`);
            return response.data;
        } catch (error) {
            console.error('Error fetching custom links:', error);
            throw error;
        }
    }

    static getCustomLinkById = async (id: string): Promise<CustomLink> => {
        try {
            const response = await axiosInstance.get<CustomLink>(`/custom-links/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching custom link:', error);
            throw error;
        }
    }

    static getCustomLinkBySlug = async (slug: string): Promise<CustomLink> => {
        try {
            const response = await axiosInstance.get<CustomLink>(`/custom-links/slug/${slug}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching custom link by slug:', error);
            throw error;
        }
    }

    static createCustomLink = async (data: CreateCustomLinkRequest): Promise<CustomLink> => {
        try {
            const response = await HttpService.post<CustomLink>(`/custom-links`, data);
            return response;
        } catch (error) {
            console.error('Error creating custom link:', error);
            throw error;
        }
    }

    static updateCustomLink = async (id: string, data: UpdateCustomLinkRequest): Promise<CustomLink> => {
        try {
            const response = await HttpService.patch<CustomLink>(`/custom-links/${id}`, data);
            return response;
        } catch (error) {
            console.error('Error updating custom link:', error);
            throw error;
        }
    }

    static deleteCustomLink = async (id: string): Promise<void> => {
        try {
            await axiosInstance.delete(`/custom-links/${id}`);
        } catch (error) {
            console.error('Error deleting custom link:', error);
            throw error;
        }
    }

    static addProductsToLink = async (id: string, productIds: string[]): Promise<CustomLink> => {
        try {
            const response = await HttpService.patch<CustomLink>(`/custom-links/${id}/products`, {
                action: 'add',
                productIds
            });
            return response;
        } catch (error) {
            console.error('Error adding products to link:', error);
            throw error;
        }
    }

    static removeProductsFromLink = async (id: string, productIds: string[]): Promise<CustomLink> => {
        try {
            const response = await HttpService.patch<CustomLink>(`/custom-links/${id}/products`, {
                action: 'remove',
                productIds
            });
            return response;
        } catch (error) {
            console.error('Error removing products from link:', error);
            throw error;
        }
    }

    static toggleLinkStatus = async (id: string, isActive: boolean): Promise<CustomLink> => {
        try {
            const response = await HttpService.patch<CustomLink>(`/custom-links/${id}/status`, {
                isActive
            });
            return response;
        } catch (error) {
            console.error('Error toggling link status:', error);
            throw error;
        }
    }
}
